import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=c2787caa&scoped=true"
import script from "./ProductsForm.vue?vue&type=script&lang=js"
export * from "./ProductsForm.vue?vue&type=script&lang=js"
import style0 from "./ProductsForm.vue?vue&type=style&index=0&id=c2787caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2787caa",
  null
  
)

export default component.exports